function getApolloErrorStatusCode (err) {
  return !!err &&
    !!err.graphQLErrors.length &&
    err.graphQLErrors[0].extensions &&
    err.graphQLErrors[0].extensions.exception &&
    err.graphQLErrors[0].extensions.exception.statusCode;
}

export default getApolloErrorStatusCode;
